import { ILead } from "../../../models/Lead";
import LeadContactDetails from "../../contacts/LeadContactDetails";
import Card from "../../shared/Card/Card";
import ClickToEdit from "../../shared/ClickToEdit";
import QuoteLocation from "../../stock/quotes/QuoteLocation";
import VehicleCollectionQuestions from "../../vehicles/VehicleCollectionQuestions";
import VehicleLocation from "../../vehicles/VehicleLocation";
import LeadContactAndVehicleDetails from "./LeadContactAndVehicleDetails";

export default function LeadContactAndVehicleTab({ lead }: { lead: ILead }) {
  return (
    <div className="[&>*]:shadow-none [&>*]:border-0 [&>*]:rounded-none">
      <ClickToEdit name="Contact & vehicle details">
        <Card title="Contact & Vehicle Pickup" bodyClassName="p-4" collapsible>
          <div className="grid grid-cols-1 gap-10 xl:grid-cols-2 xl:gap-8">
            <LeadContactDetails lead={lead} variant="embedded" />
            {lead.quoteLocation ? (
              <QuoteLocation leadId={lead.id} quoteLocation={lead.quoteLocation} variant="embedded">
                {lead.vehicle && <VehicleCollectionQuestions vehicle={lead.vehicle} />}
              </QuoteLocation>
            ) : (
              <VehicleLocation vehicle={lead.vehicle} variant="embedded" />
            )}
          </div>
        </Card>
      </ClickToEdit>
    </div>
  );
}
